import { render } from "./user_list_menu.vue?vue&type=template&id=1c1ce14c"
import script from "./user_list_menu.js?vue&type=script&lang=js"
export * from "./user_list_menu.js?vue&type=script&lang=js"

import exportComponent from "/Users/lainsoykaf/repos/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__